<template>        
       <v-autocomplete
              outlined
              v-model="inputField[keyField]"
              :items="items"
              :loading="isLoading"
              :disabled="isDisabled"
              :search-input.sync="search"          
              :multiple="isMultiple"                  
              hide-selected
              dense
              :item-text="valueText || 'userName'"
              :item-value="valueField || 'userId'"
              :label="label || $ml.get('entity')"
              prepend-inner-icon="mdi-face"
              :menu-props="{offsetY:true, maxHeight: '300px', overflowY: 'auto'}"
              :return-object="isReturnObject"
              @focus="onMenu"
              @blur="onCloseMenu"
              :ref="referenceMenu"
       >
              <!-- :placeholder="" hide-no-data -->
       <template v-slot:selection="data">              
              <v-chip
                     v-bind="data.attrs"
                     :input-value="data.selected"
                     close
                     @click="data.select"
                     @click:close="remove(data.item)"
              >
                     <v-avatar left>
                            <v-img :src="$Helper.renderImageEntity(data.item)"></v-img>
                     </v-avatar>              
                     {{ data.item.name_entity || data.item.userName }}
              </v-chip>
       </template>
       <template v-slot:item="data">
              <template v-if="typeof data.item !== 'object'">
                     <v-list-item-content>{{ data.item }}</v-list-item-content>
              </template>
              <template v-else>
                     <v-list-item-avatar>
                            <img 
                                   :src="$Helper.renderImageEntity(data.item)"
                                   @error = "item.urlImg = '/img/no_img_found.png'"
                                   crossorigin=""
                                   :key="'MenuEntityFaceImg'+data.item.userId"
                                   :width  = "50" 
                                   :height = "50"       
                            />
                     </v-list-item-avatar>
                     <v-list-item-content>
                            <v-list-item-title>{{ data.item.name_entity }}</v-list-item-title>
                            <!-- <v-list-item-subtitle v-html="data.item.group"></v-list-item-subtitle> -->
                     </v-list-item-content>
              </template>
       </template>
       </v-autocomplete>
</template>
<script>
       export default {
       name: "MenuAutocompleteTrained", 
       props:['inputField','keyField','valueField','valueText','isReturnObject','isMultiple', 'label', 'isDisabled'],
       data: () => ({
             isLoading: false,             
             search: undefined,
             list:[],
             page : 1,             
             isFetch: false,
             typingTime : null,
             referenceMenu: "MenuAutocompleteTrained",
             menuElement: null,
             nextPage: null,
       }),
       mounted(){
              this.getList();
       },
       watch: {
              search (val, old) {
                     // console.log("search ", val, old)
                     if(old && !val){
                            this.page=1                            
                            this.getList();
                     }
                     // Items have already been loaded
                     if (this.items.length > 0) return

                     clearTimeout(this.typingTime)
                     this.typingTime=setTimeout(()=>{
                            if (this.isLoading) return
                            this.isLoading = true
                            this.page=1                            
                            this.getList();
                            clearTimeout(this.typingTime)
                            this.typingTime=null
                     }, 700)
                     // Items have already been requested
                     // Lazily load input items
                    
             },
       }, // watch
       computed: {             
              items () {
                     const searchTemp=this.search?.toLowerCase();
                    return searchTemp ? this.list.filter(x=> x?.userName?.toLowerCase().includes(searchTemp) || x?.userId.includes(searchTemp)) : this.list
             },
       },

       methods:{
              async getList(){
                     try{
                            // console.log("PAGE ", this.page, this.nextPage)
                            if(this.isFetch || (this.page!==1 && !this.nextPage)) return;

                            this.isFetch=true
                            this.isLoading=true
                            const res= await this.$store.dispatch("Faces/searchFace", {
                                   page : this.page, 
                                  search: this.search ? {userName : this.search} : undefined,
                            })
                            if(res?.data){                                   
                                   this.list = this.page == 1? res.data.rows : [...this.list, ... res.data.rows]
                                   this.nextPage= res?.data?.pages > this.page ? (this.page+1) : null;                                   
                                   this.totalItems=res?.data?.count;
                            }
                     }catch(error){
                            console.warn("Error get trained ", error)
                     }finally{
                            this.isLoading=false;
                            this.isFetch=false;
                     }
              },
              onMenu(){
                     this.$nextTick(()=>{
                            const clearTime=setTimeout(()=>{
                                   const instance=this.$refs[this.referenceMenu]
                                   if(instance && instance.isMenuActive){
                                   // console.log("MENU MenuAutocompleteTrained ", instance?.$refs?.menu?.$refs)
                                          this.menuElement=instance?.$refs?.menu?.$refs?.content;
                                          if(this.menuElement){
                                                 this.menuElement.style.overflowY="auto";
                                                 this.menuElement.addEventListener("scroll", this.onScroll)
                                          }
                                   } 
                                   clearTimeout(clearTime);
                            }, 500)
                     })
              },
              onCloseMenu(){
                     if(this.menuElement){
                            this.menuElement.removeEventListener("scroll", this.onScroll);
                            this.menuElement=null;
                     }
              },
              onScroll(event){
                     const {target}=event;
                     if(!this.isLoading && this.nextPage && target.scrollTop+target.clientHeight >= target.scrollHeight-50){
                            this.page=this.nextPage;
                            this.getList();
                     }
              },
              remove (item) {                     
                     if(this.isMultiple){                            
                            if(typeof this.inputField[this.keyField] == 'string'){
                                   this.inputField[this.keyField]=[]
                            }else{                                   
                                   // console.log("CHECK ", item, this.inputField[this.keyField] )
                                   const index = this.inputField[this.keyField].findIndex(x=> x.includes(item.userId))
                                   if (index >= 0) this.inputField[this.keyField].splice(index, 1)
                            }
                     }else{
                            this.inputField[this.keyField]=[];
                     }
              },
       }, // methods
  }
</script>